let leagues = [
	// {
	// 	id: 10,
	// 	name: 'Elite Series',
	// },
	// {
	// 	id: 8,
	// 	name: 'NB Alliance',
	// },
	// {
	// 	id: 7,
	// 	name: 'NS Raiders',
	// },
	// {
	// 	id: 6,
	// 	name: 'Prospects Series Tier 2',
	// },
	// {
	// 	id: 3,
	// 	name: 'AAA Series Female',
	// },
	// {
	// 	id: 2,
	// 	name: 'Prospects Series Tier 1',
	// },
	// {
	// 	id: 1,
	// 	name: 'AAA Series Male',
	// },
]





let conferences = [
	{
		id: 18,
		name: "Nova Scotia (Selects)",
		season_id: 1,
		league_id: 11
	},
	{
		id: 17,
		name: "New Brunswick (Selects)",
		season_id: 1,
		league_id: 11
	},
	{
		id: 16,
		name: "Nova Scotia (Young Guns)",
		season_id: 1,
		league_id: 12
	},
	{
		id: 15,
		name: "New Brunswick (Young Guns)",
		season_id: 1,
		league_id: 12
	},
	{
		id: 14,
		name: "Nova Scotia Raiders",
		season_id: 1,
		league_id: 7
	},
	{
		id: 8,
		name: "NB/PEI (Prospects Series Tier 1)",
		season_id: 1,
		league_id: 2
	},
	{
		id: 7,
		name: "Nova Scotia (Prospects Series Tier 2)",
		season_id: 1,
		league_id: 6
	},
	{
		id: 6,
		name: "Nova Scotia (Prospects Series Tier 1)",
		season_id: 1,
		league_id: 2
	},
	{
		id: 5,
		name: "NB/PEI (AAA Series Female)",
		season_id: 1,
		league_id: 3
	},
	{
		id: 4,
		name: "Nova Scotia (AAA Series Male)",
		season_id: 1,
		league_id: 1
	},
	{
		id: 3,
		name: "Nova Scotia (AAA Series Female)",
		season_id: 1,
		league_id: 3
	},
	{
		id: 2,
		name: "NB/PEI (Prospects Series Tier 2)",
		season_id: 1,
		league_id: 6
	},
	{
		id: 1,
		name: "NB/PEI (AAA Series Male)",
		season_id: 1,
		league_id: 1
	},
]



let divisions = [
	{
		id: 103,
		name: "U11 (Nova Scotia Selects)",
		conference_id: 18,
		league_id: 11
	},
	{
		id: 102,
		name: "U10 (Nova Scotia Selects)",
		conference_id: 18,
		league_id: 11
	},
	{
		id: 101,
		name: "U9 (Nova Scotia Selects)",
		conference_id: 18,
		league_id: 11
	},
	{
		id: 108,
		name: "U8 (Nova Scotia Selects)",
		conference_id: 18,
		league_id: 11
	},
	{
		id: 106,
		name: "U14 (Nova Scotia Selects)",
		conference_id: 18,
		league_id: 11
	},
	{
		id: 105,
		name: "U13 (Nova Scotia Selects)",
		conference_id: 18,
		league_id: 11
	},
	{
		id: 104,
		name: "U12 (Nova Scotia Selects)",
		conference_id: 18,
		league_id: 11
	},
	{
		id: 98,
		name: "U12 (New Brunswick Selects)",
		conference_id: 17,
		league_id: 11
	},
	{
		id: 97,
		name: "U10 (New Brunswick Selects)",
		conference_id: 17,
		league_id: 11
	},
	{
		id: 96,
		name: "U11 (New Brunswick Selects)",
		conference_id: 17,
		league_id: 11
	},
	{
		id: 95,
		name: "U9 (New Brunswick Selects)",
		conference_id: 17,
		league_id: 11
	},
	{
		id: 107,
		name: "U8 (New Brunswick Selects)",
		conference_id: 17,
		league_id: 11
	},
	{
		id: 100,
		name: "U14 (New Brunswick Selects)",
		conference_id: 17,
		league_id: 11
	},
	{
		id: 99,
		name: "U13 (New Brunswick Selects)",
		conference_id: 17,
		league_id: 11
	},
	{
		id: 94,
		name: "U18 Tier 1 (Nova Scotia Young Guns)",
		conference_id: 16,
		league_id: 12
	},
	{
		id: 80,
		name: "U9 (Nova Scotia Young Guns)",
		conference_id: 16,
		league_id: 12
	},
	{
		id: 82,
		name: "U11 Tier 2 (Nova Scotia Young Guns)",
		conference_id: 16,
		league_id: 12
	},
	{
		id: 83,
		name: "U11 Tier 1 (Nova Scotia Young Guns)",
		conference_id: 16,
		league_id: 12
	},
	{
		id: 87,
		name: "U13 Tier 2 (Nova Scotia Young Guns)",
		conference_id: 16,
		league_id: 12
	},
	{
		id: 88,
		name: "U13 Tier 1 (Nova Scotia Young Guns)",
		conference_id: 16,
		league_id: 12
	},
	{
		id: 89,
		name: "U15 Tier 1 (Nova Scotia Young Guns)",
		conference_id: 16,
		league_id: 12
	},
	{
		id: 90,
		name: "U15 Tier 2 (Nova Scotia Young Guns)",
		conference_id: 16,
		league_id: 12
	},
	{
		id: 85,
		name: "U13 Tier 1 (New Brunswick Young Guns)",
		conference_id: 15,
		league_id: 12
	},
	{
		id: 81,
		name: "U11 Tier 2 (New Brunswick Young Guns)",
		conference_id: 15,
		league_id: 12
	},
	{
		id: 79,
		name: "U9 (New Brunswick Young Guns)",
		conference_id: 15,
		league_id: 12
	},
	{
		id: 93,
		name: "U18 Tier 1 (New Brunswick Young Guns)",
		conference_id: 15,
		league_id: 12
	},
	{
		id: 92,
		name: "U15 Tier 1 (New Brunswick Young Guns)",
		conference_id: 15,
		league_id: 12
	},
	{
		id: 91,
		name: "U15 Tier 2 (New Brunswick Young Guns)",
		conference_id: 15,
		league_id: 12
	},
	{
		id: 86,
		name: "U13 Tier 2 (New Brunswick Young Guns)",
		conference_id: 15,
		league_id: 12
	},
	{
		id: 84,
		name: "U11 Tier 1 (New Brunswick Young Guns)",
		conference_id: 15,
		league_id: 12
	},
	{
		id: 53,
		name: "U9 (NS Raiders)",
		conference_id: 14,
		league_id: 7
	},
	{
		id: 56,
		name: "U12 (NS Raiders)",
		conference_id: 14,
		league_id: 7
	},
	{
		id: 59,
		name: "U15 (NS Raiders)",
		conference_id: 14,
		league_id: 7
	},
	{
		id: 58,
		name: "U14 (NS Raiders)",
		conference_id: 14,
		league_id: 7
	},
	{
		id: 57,
		name: "U13 (NS Raiders)",
		conference_id: 14,
		league_id: 7
	},
	{
		id: 55,
		name: "U11 (NS Raiders)",
		conference_id: 14,
		league_id: 7
	},
	{
		id: 54,
		name: "U10 (NS Raiders)",
		conference_id: 14,
		league_id: 7
	},
	{
		id: 32,
		name: "U13 (NB/PEI Prospects Tier 1)",
		conference_id: 8,
		league_id: 2
	},
	{
		id: 31,
		name: "U11 (NB/PEI Prospects Tier 1)",
		conference_id: 8,
		league_id: 2
	},
	{
		id: 34,
		name: "U18 (NB/PEI Prospects Tier 1)",
		conference_id: 8,
		league_id: 2
	},
	{
		id: 33,
		name: "U15 (NB/PEI Prospects Tier 1)",
		conference_id: 8,
		league_id: 2
	},
	{
		id: 46,
		name: "U15 (Nova Scotia Prospects Tier 2)",
		conference_id: 7,
		league_id: 6
	},
	{
		id: 45,
		name: "U13 (Nova Scotia Prospects Tier 2)",
		conference_id: 7,
		league_id: 6
	},
	{
		id: 44,
		name: "U11 (Nova Scotia Prospects Tier 2)",
		conference_id: 7,
		league_id: 6
	},
	{
		id: 43,
		name: "U9 (Nova Scotia Prospects Tier 2)",
		conference_id: 7,
		league_id: 6
	},
	{
		id: 42,
		name: "U18 (Nova Scotia Prospects Tier 1)",
		conference_id: 6,
		league_id: 2
	},
	{
		id: 39,
		name: "U11 (Nova Scotia Prospects Tier 1)",
		conference_id: 6,
		league_id: 2
	},
	{
		id: 40,
		name: "U13 (Nova Scotia Prospects Tier 1)",
		conference_id: 6,
		league_id: 2
	},
	{
		id: 41,
		name: "U15 (Nova Scotia Prospects Tier 1)",
		conference_id: 6,
		league_id: 2
	},
	{
		id: 26,
		name: "U15 (NB/PEI AAA Series Female)",
		conference_id: 5,
		league_id: 3
	},
	{
		id: 25,
		name: "U13 (NB/PEI AAA Series Female)",
		conference_id: 5,
		league_id: 3
	},
	{
		id: 24,
		name: "U11 (NB/PEI AAA Series Female)",
		conference_id: 5,
		league_id: 3
	},
	{
		id: 23,
		name: "U9 (NB/PEI AAA Series Female)",
		conference_id: 5,
		league_id: 3
	},
	{
		id: 18,
		name: "Super 7 (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 17,
		name: "Mini (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 2002,
		name: "2012 (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 2001,
		name: "2013 (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 66,
		name: "2007 (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 2202,
		name: "2008 (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 2201,
		name: "2009 (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 2102,
		name: "2010 (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 2101,
		name: "2011 (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 1902,
		name: "2014 (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 1901,
		name: "2015 (Nova Scotia AAA Series Male)",
		conference_id: 4,
		league_id: 1
	},
	{
		id: 30,
		name: "U15 (Nova Scotia AAA Series Female)",
		conference_id: 3,
		league_id: 3
	},
	{
		id: 27,
		name: "U9 (Nova Scotia AAA Series Female)",
		conference_id: 3,
		league_id: 3
	},
	{
		id: 28,
		name: "U11 (Nova Scotia AAA Series Female)",
		conference_id: 3,
		league_id: 3
	},
	{
		id: 60,
		name: "U18 (Nova Scotia AAA Series Female)",
		conference_id: 3,
		league_id: 3
	},
	{
		id: 29,
		name: "U13 (Nova Scotia AAA Series Female)",
		conference_id: 3,
		league_id: 3
	},
	{
		id: 36,
		name: "U11 (NB/PEI Prospects Tier 2)",
		conference_id: 2,
		league_id: 6
	},
	{
		id: 38,
		name: "U15 (NB/PEI Prospects Tier 2)",
		conference_id: 2,
		league_id: 6
	},
	{
		id: 109,
		name: "U18 (NB/PEI Prospects Tier 2)",
		conference_id: 2,
		league_id: 6
	},
	{
		id: 37,
		name: "U13 (NB/PEI Prospects Tier 2)",
		conference_id: 2,
		league_id: 6
	},
	{
		id: 35,
		name: "U9 (NB/PEI Prospects Tier 2)",
		conference_id: 2,
		league_id: 6
	},
	{
		id: 502,
		name: "2012 (NB/PEI AAA Series Male)",
		conference_id: 1,
		league_id: 1
	},
	{
		id: 501,
		name: "2013 (NB/PEI AAA Series Male)",
		conference_id: 1,
		league_id: 1
	},
	{
		id: 702,
		name: "2010 (NB/PEI AAA Series Male)",
		conference_id: 1,
		league_id: 1
	},
	{
		id: 701,
		name: "2011 (NB/PEI AAA Series Male)",
		conference_id: 1,
		league_id: 1
	},
	{
		id: 902,
		name: "2008 (NB/PEI AAA Series Male)",
		conference_id: 1,
		league_id: 1
	},
	{
		id: 901,
		name: "2009 (NB/PEI AAA Series Male)",
		conference_id: 1,
		league_id: 1
	},
	{
		id: 2,
		name: "Super 7 (NB/PEI AAA Series Male)",
		conference_id: 1,
		league_id: 1
	},
	{
		id: 302,
		name: "2014 (NB/PEI AAA Series Male)",
		conference_id: 1,
		league_id: 1
	},
	{
		id: 301,
		name: "2015 (NB/PEI AAA Series Male)",
		conference_id: 1,
		league_id: 1
	},
	{
		id: 1,
		name: "Mini (NB/PEI AAA Series Male)",
		conference_id: 1,
		league_id: 1
	},
	{
		id: 48,
		name: "U10 (NB Alliance)",
		conference_id: 9999,
		league_id: 8
	},
	{
		id: 47,
		name: "U9 (NB Alliance)",
		conference_id: 9999,
		league_id: 8
	},
	{
		id: 52,
		name: "U14 (NB Alliance)",
		conference_id: 9999,
		league_id: 8
	},
	{
		id: 51,
		name: "U13 (NB Alliance)",
		conference_id: 9999,
		league_id: 8
	},
	{
		id: 50,
		name: "U12 (NB Alliance)",
		conference_id: 9999,
		league_id: 8
	},
	{
		id: 49,
		name: "U11 (NB Alliance)",
		conference_id: 9999,
		league_id: 8
	},
]





let team_instances = [
	{
		name: "Thunder",
		division_id: 2001,
		id: 1421,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Tidal Wave",
		division_id: 2001,
		id: 1420,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Storm",
		division_id: 2001,
		id: 1419,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Lightning",
		division_id: 2001,
		id: 1418,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Knights",
		division_id: 2001,
		id: 1417,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Jr. Lumberjacks",
		division_id: 2001,
		id: 1416,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Jr. Axemen",
		division_id: 2001,
		id: 1415,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Hurricanes",
		division_id: 2001,
		id: 1414,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Heat",
		division_id: 2001,
		id: 1413,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Freeze",
		division_id: 2001,
		id: 1412,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Blue Battalion",
		division_id: 2001,
		id: 1411,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Admirals",
		division_id: 2001,
		id: 1410,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Aces",
		division_id: 2001,
		id: 1409,
		conference_id: 4,
		league_id: 1
	},
	{
		name: "Penguins",
		division_id: 41,
		id: 1541,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Bears",
		division_id: 41,
		id: 1568,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Independently Registered Players",
		division_id: 9999,
		id: 1540,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Huskies",
		division_id: 41,
		id: 1538,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Huskies",
		division_id: 39,
		id: 1537,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Lions",
		division_id: 34,
		id: 1536,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Hawks",
		division_id: 34,
		id: 1535,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Mini Heat",
		division_id: 17,
		id: 1532,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Cougars",
		division_id: 901,
		id: 1531,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Cougars",
		division_id: 702,
		id: 1530,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Cougars",
		division_id: 701,
		id: 1529,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Cougars",
		division_id: 502,
		id: 1528,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Cougars",
		division_id: 501,
		id: 1527,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Cougars",
		division_id: 302,
		id: 1526,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Cougars",
		division_id: 301,
		id: 1525,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Cougars",
		division_id: 2,
		id: 1524,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Stars",
		division_id: 901,
		id: 1523,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Vipers",
		division_id: 901,
		id: 1522,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Titan",
		division_id: 901,
		id: 1521,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Lynx",
		division_id: 901,
		id: 1520,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Jr. Caps",
		division_id: 901,
		id: 1519,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus",
		division_id: 901,
		id: 1518,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Titan",
		division_id: 702,
		id: 1517,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Jr. Caps",
		division_id: 702,
		id: 1516,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus",
		division_id: 702,
		id: 1515,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Vipers",
		division_id: 701,
		id: 1547,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Titan",
		division_id: 701,
		id: 1514,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Lynx",
		division_id: 701,
		id: 1513,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Jr. Caps",
		division_id: 701,
		id: 1512,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus",
		division_id: 701,
		id: 1511,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Vipers",
		division_id: 502,
		id: 1510,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Titan",
		division_id: 502,
		id: 1509,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Lynx",
		division_id: 502,
		id: 1508,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Jr. Caps",
		division_id: 502,
		id: 1507,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Titan",
		division_id: 501,
		id: 1506,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Lynx",
		division_id: 501,
		id: 1505,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Jr. Caps",
		division_id: 501,
		id: 1504,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Huskies",
		division_id: 501,
		id: 1503,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus",
		division_id: 501,
		id: 1502,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Vipers",
		division_id: 302,
		id: 1501,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Titan",
		division_id: 302,
		id: 1500,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Lynx",
		division_id: 302,
		id: 1499,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Jr. Caps",
		division_id: 302,
		id: 1498,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Huskies",
		division_id: 302,
		id: 1497,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus",
		division_id: 302,
		id: 1496,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Vipers",
		division_id: 301,
		id: 1495,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Titan",
		division_id: 301,
		id: 1494,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Lynx",
		division_id: 301,
		id: 1493,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Jr. Caps",
		division_id: 301,
		id: 1492,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Huskies",
		division_id: 301,
		id: 1491,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus",
		division_id: 301,
		id: 1490,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Vipers",
		division_id: 2,
		id: 1489,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Titan",
		division_id: 2,
		id: 1488,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Lynx",
		division_id: 2,
		id: 1487,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Jr. Caps",
		division_id: 2,
		id: 1486,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Huskies",
		division_id: 2,
		id: 1485,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus",
		division_id: 2,
		id: 1484,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Jr. Caps",
		division_id: 1,
		id: 1483,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Vipers/Aigles",
		division_id: 1,
		id: 1482,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus",
		division_id: 1,
		id: 1481,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "Trailblazers",
		division_id: 26,
		id: 1480,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Bardown Beauties",
		division_id: 26,
		id: 1479,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus Espoirs",
		division_id: 26,
		id: 1478,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Trailblazers",
		division_id: 25,
		id: 1477,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Bardown Beauties",
		division_id: 25,
		id: 1476,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus Espoirs",
		division_id: 25,
		id: 1475,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Bardown Beauties",
		division_id: 24,
		id: 1474,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus Espoirs",
		division_id: 24,
		id: 1473,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Trailblazers",
		division_id: 24,
		id: 1472,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Trailblazers",
		division_id: 23,
		id: 1471,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Bardown Beauties",
		division_id: 23,
		id: 1470,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Aigles Bleus Espoirs",
		division_id: 23,
		id: 1469,
		conference_id: 5,
		league_id: 9999,
	},
	{
		name: "Thunder",
		division_id: 2201,
		id: 1468,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Tidal Wave",
		division_id: 2201,
		id: 1467,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Storm",
		division_id: 2201,
		id: 1466,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Lightning",
		division_id: 2201,
		id: 1465,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Lumberjacks",
		division_id: 2201,
		id: 1464,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Axemen",
		division_id: 2201,
		id: 1463,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Hurricanes",
		division_id: 2201,
		id: 1462,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Heat",
		division_id: 2201,
		id: 1461,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Freeze",
		division_id: 2201,
		id: 1460,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Blue Battalion",
		division_id: 2201,
		id: 1459,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 2201,
		id: 1458,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Thunder",
		division_id: 2102,
		id: 1457,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Tidal Wave",
		division_id: 2102,
		id: 1456,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Storm",
		division_id: 2102,
		id: 1455,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Lightning",
		division_id: 2102,
		id: 1454,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Lumberjacks",
		division_id: 2102,
		id: 1453,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Axemen",
		division_id: 2102,
		id: 1452,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Hurricanes",
		division_id: 2102,
		id: 1451,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Raiders",
		division_id: 2102,
		id: 1450,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Highlanders",
		division_id: 2102,
		id: 1449,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Eagles",
		division_id: 2102,
		id: 1448,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Blue Battalion",
		division_id: 2102,
		id: 1447,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 2102,
		id: 1446,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Tidal Wave",
		division_id: 2101,
		id: 1445,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Thunder",
		division_id: 2101,
		id: 1444,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Storm",
		division_id: 2101,
		id: 1443,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Lightning",
		division_id: 2101,
		id: 1442,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Lumberjacks",
		division_id: 2101,
		id: 1441,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Axemen",
		division_id: 2101,
		id: 1440,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Hurricanes",
		division_id: 2101,
		id: 1439,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Heat",
		division_id: 2101,
		id: 1438,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Freeze",
		division_id: 2101,
		id: 1437,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Blue Battalion",
		division_id: 2101,
		id: 1436,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 2101,
		id: 1435,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Axemen",
		division_id: 2002,
		id: 1434,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Knights",
		division_id: 2002,
		id: 1433,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Hurricanes",
		division_id: 2002,
		id: 1432,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Heat",
		division_id: 2002,
		id: 1431,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Freeze",
		division_id: 2002,
		id: 1430,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Blue Battalion",
		division_id: 2002,
		id: 1429,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 2002,
		id: 1428,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Lumberjacks",
		division_id: 2002,
		id: 1427,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Thunder",
		division_id: 2002,
		id: 1426,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Tidal Wave",
		division_id: 2002,
		id: 1425,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Storm",
		division_id: 2002,
		id: 1424,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Lightning",
		division_id: 2002,
		id: 1423,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Aces",
		division_id: 2002,
		id: 1422,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Thunder",
		division_id: 1902,
		id: 1408,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Tidal Wave",
		division_id: 1902,
		id: 1407,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Storm",
		division_id: 1902,
		id: 1406,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Lightning",
		division_id: 1902,
		id: 1405,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Lumberjacks",
		division_id: 1902,
		id: 1404,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Axemen",
		division_id: 1902,
		id: 1403,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Hurricanes",
		division_id: 1902,
		id: 1402,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Heat",
		division_id: 1902,
		id: 1401,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Freeze",
		division_id: 1902,
		id: 1400,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Blue Battalion",
		division_id: 1902,
		id: 1399,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 1902,
		id: 1398,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Thunder",
		division_id: 1901,
		id: 1397,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Tidal Wave",
		division_id: 1901,
		id: 1396,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Storm",
		division_id: 1901,
		id: 1395,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Lightning",
		division_id: 1901,
		id: 1394,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Lumberjacks",
		division_id: 1901,
		id: 1393,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Axemen",
		division_id: 1901,
		id: 1392,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Hurricanes",
		division_id: 1901,
		id: 1391,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Freeze",
		division_id: 1901,
		id: 1390,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 1901,
		id: 1389,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Blue Battalion",
		division_id: 1901,
		id: 1388,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Tidal Wave",
		division_id: 18,
		id: 1387,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Storm",
		division_id: 18,
		id: 1386,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Lightning",
		division_id: 18,
		id: 1385,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Lumberjacks",
		division_id: 18,
		id: 1384,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Axemen",
		division_id: 18,
		id: 1383,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Hurricanes",
		division_id: 18,
		id: 1382,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Freeze",
		division_id: 18,
		id: 1381,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 18,
		id: 1380,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Mini Battalion",
		division_id: 17,
		id: 1379,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Mini Waves",
		division_id: 17,
		id: 1378,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Jr. Axemen",
		division_id: 17,
		id: 1377,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Freeze",
		division_id: 17,
		id: 1376,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Mini Admirals",
		division_id: 17,
		id: 1375,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Independently Registered Players",
		division_id: 46,
		id: 1374,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 46,
		id: 1373,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Red Wings",
		division_id: 46,
		id: 1372,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Penguins",
		division_id: 46,
		id: 1371,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Oilers",
		division_id: 46,
		id: 1370,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Maple Leafs",
		division_id: 46,
		id: 1369,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Knights",
		division_id: 46,
		id: 1368,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Kings",
		division_id: 46,
		id: 1367,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Jets",
		division_id: 46,
		id: 1366,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Flyers",
		division_id: 46,
		id: 1365,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Canadiens",
		division_id: 46,
		id: 1363,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Bruins",
		division_id: 46,
		id: 1362,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Independently Registered Players",
		division_id: 45,
		id: 1361,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 45,
		id: 1360,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Sabres",
		division_id: 45,
		id: 1561,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Red Wings",
		division_id: 45,
		id: 1359,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Penguins",
		division_id: 45,
		id: 1358,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Oilers",
		division_id: 45,
		id: 1357,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Maple Leafs",
		division_id: 45,
		id: 1356,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Knights",
		division_id: 45,
		id: 1355,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Kings",
		division_id: 45,
		id: 1354,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Jets",
		division_id: 45,
		id: 1353,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Blues",
		division_id: 45,
		id: 1604,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Flyers",
		division_id: 45,
		id: 1352,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Canadiens",
		division_id: 45,
		id: 1351,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Bruins",
		division_id: 45,
		id: 1350,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Independently Registered Players",
		division_id: 44,
		id: 1349,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Stars",
		division_id: 44,
		id: 1348,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 44,
		id: 1347,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Red Wings",
		division_id: 44,
		id: 1346,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Penguins",
		division_id: 44,
		id: 1345,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Oilers",
		division_id: 44,
		id: 1344,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Maple Leafs",
		division_id: 44,
		id: 1343,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Knights",
		division_id: 44,
		id: 1342,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Jets",
		division_id: 44,
		id: 1341,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Flyers",
		division_id: 44,
		id: 1340,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Canadiens",
		division_id: 44,
		id: 1339,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Bruins",
		division_id: 44,
		id: 1338,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Canadiens",
		division_id: 43,
		id: 1337,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Bruins",
		division_id: 43,
		id: 1336,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Independently Registered Players",
		division_id: 43,
		id: 1335,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Knights",
		division_id: 43,
		id: 1334,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Kings",
		division_id: 43,
		id: 1333,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Flyers",
		division_id: 43,
		id: 1332,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Stars",
		division_id: 43,
		id: 1331,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 43,
		id: 1330,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Red Wings",
		division_id: 43,
		id: 1329,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Penguins",
		division_id: 43,
		id: 1328,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Oilers",
		division_id: 43,
		id: 1327,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Maple Leafs",
		division_id: 43,
		id: 1326,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Jets",
		division_id: 43,
		id: 1325,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Wolves",
		division_id: 41,
		id: 1324,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Panthers",
		division_id: 41,
		id: 1323,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Oilers",
		division_id: 41,
		id: 1322,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Lions",
		division_id: 41,
		id: 1321,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Jaguars",
		division_id: 41,
		id: 1320,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Hawks",
		division_id: 41,
		id: 1319,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Eagles",
		division_id: 41,
		id: 1318,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Bulls",
		division_id: 41,
		id: 1317,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Bulldogs",
		division_id: 41,
		id: 1316,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Bengals",
		division_id: 41,
		id: 1315,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Barracudas",
		division_id: 41,
		id: 1314,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Wolves",
		division_id: 40,
		id: 1313,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Panthers",
		division_id: 40,
		id: 1312,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Lions",
		division_id: 40,
		id: 1311,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Jaguars",
		division_id: 40,
		id: 1310,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Hawks",
		division_id: 40,
		id: 1309,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Eagles",
		division_id: 40,
		id: 1308,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Coyotes",
		division_id: 40,
		id: 1307,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Bulls",
		division_id: 40,
		id: 1306,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Bulldogs",
		division_id: 40,
		id: 1305,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Bengals",
		division_id: 40,
		id: 1304,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Barracudas",
		division_id: 40,
		id: 1303,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Panthers",
		division_id: 39,
		id: 1302,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Wolves",
		division_id: 39,
		id: 1301,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Lions",
		division_id: 39,
		id: 1300,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Jaguars",
		division_id: 39,
		id: 1299,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Hawks",
		division_id: 39,
		id: 1298,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Eagles",
		division_id: 39,
		id: 1297,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Coyotes",
		division_id: 39,
		id: 1296,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Bulls",
		division_id: 39,
		id: 1295,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Bengals",
		division_id: 39,
		id: 1294,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Barracudas",
		division_id: 39,
		id: 1293,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Sting",
		division_id: 60,
		id: 1292,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Rush",
		division_id: 60,
		id: 1291,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Pride",
		division_id: 60,
		id: 1290,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Flash",
		division_id: 60,
		id: 1289,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Force",
		division_id: 60,
		id: 1288,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Comets",
		division_id: 60,
		id: 1287,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Express",
		division_id: 60,
		id: 1286,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 60,
		id: 1285,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Sting",
		division_id: 30,
		id: 1284,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Rush",
		division_id: 30,
		id: 1283,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Pride",
		division_id: 30,
		id: 1282,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Flash",
		division_id: 30,
		id: 1281,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Force",
		division_id: 30,
		id: 1280,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Express",
		division_id: 30,
		id: 1279,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Comets",
		division_id: 30,
		id: 1278,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 30,
		id: 1277,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Sting",
		division_id: 29,
		id: 1276,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Rush",
		division_id: 29,
		id: 1275,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Pride",
		division_id: 29,
		id: 1274,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Force",
		division_id: 29,
		id: 1273,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Flash",
		division_id: 29,
		id: 1272,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Express",
		division_id: 29,
		id: 1271,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Comets",
		division_id: 29,
		id: 1270,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 29,
		id: 1269,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Sting",
		division_id: 28,
		id: 1268,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Rush",
		division_id: 28,
		id: 1267,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Pride",
		division_id: 28,
		id: 1266,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Force",
		division_id: 28,
		id: 1265,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Flash",
		division_id: 28,
		id: 1264,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Express",
		division_id: 28,
		id: 1263,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Comets",
		division_id: 28,
		id: 1262,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 28,
		id: 1261,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Sting",
		division_id: 27,
		id: 1260,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Rush",
		division_id: 27,
		id: 1259,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Pride",
		division_id: 27,
		id: 1258,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Force",
		division_id: 27,
		id: 1257,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Flash",
		division_id: 27,
		id: 1256,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Express",
		division_id: 27,
		id: 1255,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Comets",
		division_id: 27,
		id: 1254,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Admirals",
		division_id: 27,
		id: 1253,
		conference_id: 3,
		league_id: 9999,
	},
	{
		name: "Trailblazers",
		division_id: 38,
		id: 1252,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Stars",
		division_id: 38,
		id: 1251,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 38,
		id: 1250,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Penguins",
		division_id: 38,
		id: 1249,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Oilers",
		division_id: 38,
		id: 1248,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Nordiques",
		division_id: 38,
		id: 1247,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Maple Leafs",
		division_id: 38,
		id: 1246,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Flyers",
		division_id: 38,
		id: 1245,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Canadiens",
		division_id: 38,
		id: 1244,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Bruins",
		division_id: 38,
		id: 1243,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Bruins",
		division_id: 109,
		id: 1550,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Canadiens",
		division_id: 109,
		id: 1549,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Stars",
		division_id: 109,
		id: 1548,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Oilers",
		division_id: 109,
		id: 1542,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Knights",
		division_id: 37,
		id: 1546,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Whalers",
		division_id: 37,
		id: 1242,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Trailblazers",
		division_id: 37,
		id: 1241,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Stars",
		division_id: 37,
		id: 1240,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 37,
		id: 1239,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Kings",
		division_id: 37,
		id: 1554,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Penguins",
		division_id: 37,
		id: 1238,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Oilers",
		division_id: 37,
		id: 1237,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Maple Leafs",
		division_id: 37,
		id: 1236,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Flyers",
		division_id: 37,
		id: 1235,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Canadiens",
		division_id: 37,
		id: 1234,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Bruins",
		division_id: 37,
		id: 1233,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Whalers",
		division_id: 36,
		id: 1232,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Trailblazers",
		division_id: 36,
		id: 1231,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Stars",
		division_id: 36,
		id: 1230,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 36,
		id: 1229,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Penguins",
		division_id: 36,
		id: 1228,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Oilers",
		division_id: 36,
		id: 1227,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Maple Leafs",
		division_id: 36,
		id: 1226,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Bruins",
		division_id: 36,
		id: 1225,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Whalers",
		division_id: 35,
		id: 1224,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Trailblazers",
		division_id: 35,
		id: 1223,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Stars",
		division_id: 35,
		id: 1222,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 35,
		id: 1221,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Penguins",
		division_id: 35,
		id: 1220,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Oilers",
		division_id: 35,
		id: 1219,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Maple Leafs",
		division_id: 35,
		id: 1218,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Flyers",
		division_id: 35,
		id: 1217,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Canadiens",
		division_id: 35,
		id: 1216,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Bruins",
		division_id: 35,
		id: 1215,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Wolves",
		division_id: 34,
		id: 1214,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Whalers",
		division_id: 34,
		id: 1213,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 34,
		id: 1212,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Titan",
		division_id: 34,
		id: 1211,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Tigers",
		division_id: 34,
		id: 1210,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Jaguars",
		division_id: 34,
		id: 1209,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bulls",
		division_id: 34,
		id: 1208,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bulldogs",
		division_id: 34,
		id: 1207,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bengals",
		division_id: 34,
		id: 1206,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Wolves",
		division_id: 33,
		id: 1205,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Whalers",
		division_id: 33,
		id: 1204,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 33,
		id: 1203,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Tigers",
		division_id: 33,
		id: 1202,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Lions",
		division_id: 33,
		id: 1201,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Jaguars",
		division_id: 33,
		id: 1200,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bulls",
		division_id: 33,
		id: 1199,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bulldogs",
		division_id: 33,
		id: 1198,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bengals",
		division_id: 33,
		id: 1197,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Wolves",
		division_id: 32,
		id: 1196,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Whalers",
		division_id: 32,
		id: 1195,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 32,
		id: 1194,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Tigers",
		division_id: 32,
		id: 1193,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Lions",
		division_id: 32,
		id: 1192,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Jaguars",
		division_id: 32,
		id: 1191,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bulldogs",
		division_id: 32,
		id: 1190,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bulls",
		division_id: 32,
		id: 1189,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bengals",
		division_id: 32,
		id: 1188,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Wolves",
		division_id: 31,
		id: 1187,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Whalers",
		division_id: 31,
		id: 1186,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Sharks",
		division_id: 31,
		id: 1185,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Tigers",
		division_id: 31,
		id: 1184,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Lions",
		division_id: 31,
		id: 1183,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Jaguars",
		division_id: 31,
		id: 1182,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bulls",
		division_id: 31,
		id: 1181,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bulldogs",
		division_id: 31,
		id: 1180,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Bengals",
		division_id: 31,
		id: 1179,
		conference_id: 8,
		league_id: 9999,
	},
	{
		name: "Canadiens",
		division_id: 36,
		id: 1178,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Heat",
		division_id: 18,
		id: 1177,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Stars",
		division_id: 46,
		id: 1175,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Stars",
		division_id: 45,
		id: 1173,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Kings",
		division_id: 44,
		id: 1172,
		conference_id: 7,
		league_id: 9999,
	},
	{
		name: "Blue Battalion",
		division_id: 18,
		id: 1171,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Coyotes",
		division_id: 41,
		id: 1170,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Flyers",
		division_id: 36,
		id: 1169,
		conference_id: 2,
		league_id: 9999,
	},
	{
		name: "Bulldogs",
		division_id: 39,
		id: 1168,
		conference_id: 6,
		league_id: 9999,
	},
	{
		name: "Heat",
		division_id: 1901,
		id: 1165,
		conference_id: 4,
		league_id: 9999,
	},
	{
		name: "Vipers",
		division_id: 501,
		id: 1159,
		conference_id: 1,
		league_id: 9999,
	},
	{
		name: "NS Raiders (U9)",
		division_id: 53,
		id: 1140,
		conference_id: 9999,
		league_id: 9999,
	},
	{
		name: "NS Raiders (U10)",
		division_id: 54,
		id: 1139,
		conference_id: 9999,
		league_id: 9999,
	},
	{
		name: "NS Raiders (U11)",
		division_id: 55,
		id: 1138,
		conference_id: 9999,
		league_id: 9999,
	},
	{
		name: "NS Raiders (U12)",
		division_id: 56,
		id: 1137,
		conference_id: 9999,
		league_id: 9999,
	},
	{
		name: "NS Raiders (U13)",
		division_id: 57,
		id: 1136,
		conference_id: 9999,
		league_id: 9999,
	},
	{
		name: "NS Raiders (U14)",
		division_id: 58,
		id: 1135,
		conference_id: 9999,
		league_id: 9999,
	},
	{
		name: "NS Raiders (U15)",
		division_id: 59,
		id: 1134,
		conference_id: 9999,
		league_id: 9999,
	}
]




export {
	leagues,
	conferences,
	divisions,
	team_instances,
}


